import { render } from "./AguardandoAprovacao.vue?vue&type=template&id=3585c584&scoped=true"
import script from "./AguardandoAprovacao.vue?vue&type=script&lang=js"
export * from "./AguardandoAprovacao.vue?vue&type=script&lang=js"

import "./AguardandoAprovacao.vue?vue&type=style&index=0&id=3585c584&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.g.adm\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3585c584"]])

export default __exports__